module.exports = __webpack_public_path__ + "img/img4.b5ab668e.png";